import React, { useState, useContext, useEffect } from "react";
import {
  Row, Col, Card, Form,
  Button, Table, Badge, Dropdown,
} from "react-bootstrap";
import {
  FaUserShield, FaPlus,
  FaEllipsisV, FaEdit,
  FaBan, FaTrash, FaCheck,
} from "react-icons/fa";
import axios from "axios";
import AppPagination from "../../../components/general/pagination/Pagination.js";
import AppContext from '../../../context/AppContext.js';
import MasterLayout from "../../../layout/superadmin/MasterLayout";
import "../../../assets/css/superadmin/subadmin/subadmin.css";
import Swal from "sweetalert2";

const SubAdmin = () => {
  const { baseUrl, regExpChecker, authToken, loggedInAdmin } = useContext(AppContext);
  const isModerator = loggedInAdmin?.issuper === 'moderator';
  const [subadmins, setSubAdmins] = useState([]);
  const [firstname, setFirstName] = useState("");
  const [lastname, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [issuper, setIsSuper] = useState("");
  const [idToUpdateDeleteSubAdmin, setIDToUpdateDeleteSubAdmin] = useState("");
  const [errorMessage, setErrorMessage] = useState();
  const [editId, setEditId] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const ENTRIES_PER_PAGE = 4;

 // ✅ UPDATED: pehle empty-check (generic message), phir format-check (regExpChecker)
const validateForm = () => {
  if (!firstname.trim() || !lastname.trim() || !email.trim() || (!editId && !password.trim()) || !issuper) {
    Swal.fire({
      title: "Missing Information",
      text: "Please enter your data.",
      icon: "warning",
    });
    return false;
  }

  const firstNameError = regExpChecker("username", firstname);
  if (firstNameError) {
    Swal.fire({ title: "Invalid First Name", text: firstNameError, icon: "warning" });
    return false;
  }

  const lastNameError = regExpChecker("username", lastname);
  if (lastNameError) {
    Swal.fire({ title: "Invalid Last Name", text: lastNameError, icon: "warning" });
    return false;
  }

  const emailError = regExpChecker("email", email);
  if (emailError) {
    Swal.fire({ title: "Invalid Email", text: emailError, icon: "warning" });
    return false;
  }

  // Edit mode mein password khali chor sakte hain ("Leave blank to keep")
  if (!editId || password) {
    const passwordError = regExpChecker("password", password);
    if (passwordError) {
      Swal.fire({ title: "Invalid Password", text: passwordError, icon: "warning" });
      return false;
    }
  }

  return true;
};

 const createSubAdmin = () => {
  const formData = new FormData();

  formData.append("firstname", firstname);
  formData.append("lastname", lastname);
  formData.append("password", password);
  formData.append("email", email);
  formData.append("issuper", issuper);

  axios.post(
    `${baseUrl}/superadmin/subadmin/createSubAdmin`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${authToken}`,
      },
    }
  )
  .then((response) => {
    console.log(response.data);

    if (response.data.success) {
      Swal.fire({
        title: "Congratulations!",
        text: "Admin Created successfuly",
        icon: "success",
        confirmButtonText: "Wow"
      });

      viewAllSubAdmins();
      resetForm();
    } else {
      Swal.fire({
        title: "Failed",
        text: response.data.message || "Something went wrong.",
        icon: "error",
      });
    }
  })
  .catch((error) => {
    console.log(error);
    Swal.fire({
      title: "Error",
      text: "Could not create admin.",
      icon: "error"
    });
  });
};

  const updateSubAdmin = () => {
    const formData = new FormData();
    formData.append("id", idToUpdateDeleteSubAdmin);
    formData.append("firstname", firstname);
    formData.append("lastname", lastname);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("issuper", issuper);
    axios.post(`${baseUrl}/superadmin/subadmin/updatesubadmin`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${authToken}`,
      },
    }).then((response) => {
      console.log(response.data);
      if (response.data.success) {
        Swal.fire({
          title: "Updated!",
          text: "Admin updated successfully",
          icon: "success",
          confirmButtonText: "OK"
        });
        viewAllSubAdmins();
        resetForm();
      } else {
        Swal.fire({
          title: "Failed",
          text: response.data.message || "Something went wrong.",
          icon: "error",
        });
      }
    }).catch((error) => {
      console.log(error);
      Swal.fire({ title: "Error", text: "Could not update admin.", icon: "error" });
    });
  };

  const deleteSubAdmin = (id) => {
    const formData = new FormData();
    formData.append("id", id);
    axios.post(`${baseUrl}/superadmin/subadmin/deleteSubAdmin`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${authToken}`,
      },
    }).then((response) => {
      console.log(response.data);
      viewAllSubAdmins();
    }).catch((error) => {
      console.log(error);
    });
  };

  const viewAllSubAdmins = () => {
    axios.get(`${baseUrl}/superadmin/subadmin/viewAllSubAdmins`, {
     headers: {
      Authorization: `Bearer ${authToken}`
      } }
    )
      .then((response) => {
        console.log("API Response:", response.data);
        if (response.data.success && response.data.data) {
          setSubAdmins(response.data.data);
        } else {
          setSubAdmins([]);
        }
      }).catch((error) => {
        console.log(error);
        setSubAdmins([]);
      });
  };

  useEffect(() => {
    viewAllSubAdmins();
  }, []);

  const toggleStatus = (id, isCurrentlyActive) => {
    console.log("Toggle ID:", id);
    console.log("isCurrentlyActive:", isCurrentlyActive);
    const formData = new FormData();
    formData.append("id", id);
    formData.append("status", isCurrentlyActive ? "inactive" : "active");
    axios.post(`${baseUrl}/superadmin/subadmin/updatesubadmin`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        "Authorization": `Bearer ${authToken}`,
      },
    }).then((response) => {
      console.log("Toggle response:", response.data);
      viewAllSubAdmins();
    }).catch((error) => {
      console.log("Toggle error:", error);
    });
  };

  const edit = (subadmin) => {
    setEditId(true);
    setIDToUpdateDeleteSubAdmin(subadmin.id);
    setFirstName(subadmin.firstname);
    setLastName(subadmin.lastname);
    setEmail(subadmin.email);
    setPassword(subadmin.password);
    setIsSuper(subadmin.issuper || "moderator");
  };

  const resetForm = () => {
    setEditId(false);
    setIDToUpdateDeleteSubAdmin("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setPassword("");
    setIsSuper("");
    setErrorMessage("");
  };

  const totalPages = Math.ceil(subadmins.length / ENTRIES_PER_PAGE);
  const paginated = subadmins.slice((currentPage - 1) * ENTRIES_PER_PAGE, currentPage * ENTRIES_PER_PAGE);

  // ── A moderator has no business managing other admins — block this
  // page entirely even if they reach it by typing the URL directly. ──
  if (isModerator) {
    return (
      <MasterLayout>
        <div className="sam-wrapper">
          <div className="sam-page-header">
            <h1 className="sam-page-title">Access Restricted</h1>
            <p className="sam-page-sub">
              Only a superadmin can manage sub-admins. You're logged in as a moderator.
            </p>
          </div>
        </div>
      </MasterLayout>
    );
  }

  return (
    <MasterLayout>
      <div className="sam-wrapper">

        {/* Page Header */}
        <div className="sam-page-header">
          <h1 className="sam-page-title">Sub-Admin Management</h1>
          <p className="sam-page-sub">Manage administrative permissions and access levels for system operators.</p>
        </div>

        {/* Add / Edit Form Card */}
        <Card className="sam-card sam-form-card mb-4">
          <Card.Body>
            <div className="sam-form-header">
              <FaUserShield className="sam-form-icon" />
              <span className="sam-form-title">
                {editId ? "Edit Sub-Admin" : "Add New Sub-Admin"}
              </span>
            </div>

            <Row className="g-3 mt-1">
              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label className="sam-label">First Name</Form.Label>
                  <Form.Control
                    className="sam-input"
                    placeholder="John"
                    value={firstname}
                    onChange={(e) => {
                      setFirstName(e.target.value);
                      setErrorMessage(regExpChecker("username", e.target.value));
                    }}
                  />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label className="sam-label">Last Name</Form.Label>
                  <Form.Control
                    className="sam-input"
                    placeholder="Doe"
                    value={lastname}
                    onChange={(e) => {
                      setLastName(e.target.value);
                      setErrorMessage(regExpChecker("username", e.target.value));
                    }
                    }
                  />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label className="sam-label">Email Address</Form.Label>
                  <Form.Control
                    type="email"
                    className="sam-input"
                    placeholder="john.doe@agrimachinery.com"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      setErrorMessage(regExpChecker("email", e.target.value));
                    }}
                  />
                </Form.Group>
              </Col>

              <Col xs={12} sm={6} lg={3}>
                <Form.Group>
                  <Form.Label className="sam-label">Password</Form.Label>
                  <Form.Control
                    type="password"
                    className="sam-input"
                    placeholder={editId ? "Leave blank to keep" : "••••••••"}
                    value={password}
                    onChange={(e) => {
                      setPassword(e.target.value);
                      setErrorMessage(regExpChecker("password", e.target.value));
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="sam-form-footer mt-3">
              <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                <span className="sam-label" style={{ marginBottom: 0, fontWeight: '600' }}>Role:</span>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontWeight: '500' }}>
                  <input
                    type="radio"
                    name="issuper"
                    value="superadmin"
                    checked={issuper === "superadmin"}
                    onChange={(e) => setIsSuper(e.target.value)}
                    style={{ accentColor: '#FDB714', width: '16px', height: '16px' }}
                  />
                  Superadmin
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer', fontWeight: '500' }}>
                  <input
                    type="radio"
                    name="issuper"
                    value="moderator"
                    checked={issuper === "moderator"}
                    onChange={(e) => setIsSuper(e.target.value)}
                    style={{ accentColor: '#FDB714', width: '16px', height: '16px' }}
                  />
                  Moderator
                </label>
              </div>

              <div className="sam-form-actions">
                {editId && (
                  <Button className="sam-cancel-btn" onClick={resetForm}>Cancel</Button>
                )}
                {errorMessage && <p style={{ color: "red", fontSize: "0.8rem", marginTop: "4px" }}>{errorMessage}</p>}
                <Button
                  className="sam-create-btn"
                  onClick={() => {
                    if (!validateForm()) return;
                    editId ? updateSubAdmin() : createSubAdmin();
                  }}
                >
                  {editId ? <><FaCheck size={13} /> Update Admin</> : <><FaPlus size={13} /> Create Admin</>}
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>

        {/* Existing Sub-Admins Table Card */}
        <Card className="sam-card">
          <Card.Body className="p-0">

            <div className="sam-table-header">
              <span className="sam-table-title">Existing Sub-Admins</span>
            </div>

            <Table className="sam-table" hover>
              <thead>
                <tr>
                  <th>FIRSTNAME</th>
                  <th>LASTNAME</th>
                  <th>EMAIL</th>
                  <th>ROLE</th>
                  <th>STATUS</th>
                  <th className="text-end">ACTIONS</th>
                </tr>
              </thead>
              <tbody>
                {paginated.map(admin => {
                  const isActive = admin.status === 'active';
                  return (
                    <tr key={admin.id}>
                      <td className="sam-td-name">{admin.firstname}</td>
                      <td>{admin.lastname}</td>
                      <td className="sam-td-email">{admin.email}</td>
                      <td><span className="sam-role-badge">{admin.issuper}</span></td>
                      <td>
                        <Badge className={`sam-status-badge ${isActive ? 'active' : 'inactive'}`}>
                          {isActive ? 'Active' : 'Inactive'}
                        </Badge>
                      </td>
                      <td className="text-end">
                        <Dropdown align="end">
                          <Dropdown.Toggle as="button" className="sam-dot-btn" id={`dd-${admin.id}`}>
                            <FaEllipsisV size={14} />
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="sam-dropdown-menu">
                            <Dropdown.Item className="sam-drop-item edit" onClick={() => edit(admin)}>
                              <FaEdit size={13} /> Edit
                            </Dropdown.Item>
                            <Dropdown.Item className="sam-drop-item disable" onClick={() => toggleStatus(admin.id, isActive)}>
                              <FaBan size={13} /> {isActive ? "Disable" : "Enable"}
                            </Dropdown.Item>
                            <Dropdown.Divider className="sam-drop-divider" />
                            <Dropdown.Item className="sam-drop-item delete" onClick={() => deleteSubAdmin(admin.id)}>
                              <FaTrash size={13} /> Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <AppPagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={subadmins.length}
              itemsPerPage={ENTRIES_PER_PAGE}
              onPageChange={(page) => setCurrentPage(page)}
            />

          </Card.Body>
        </Card>
      </div>
    </MasterLayout>
  );
};

export default SubAdmin;